import { render, staticRenderFns } from "./BooksList.vue?vue&type=template&id=2be020d0&"
import script from "./BooksList.vue?vue&type=script&lang=js&"
export * from "./BooksList.vue?vue&type=script&lang=js&"
import style0 from "./BooksList.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports